import { render, staticRenderFns } from "./SongView.vue?vue&type=template&id=741ce6e7&lang=html&"
import script from "./SongView.vue?vue&type=script&lang=js&"
export * from "./SongView.vue?vue&type=script&lang=js&"
import style0 from "./SongView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SongView.vue"
export default component.exports